import React, { useState, useEffect } from 'react';
import StatusBadge from './StatusBadge';
import ValidationErrors from './ValidationErrors';
import RejectionDetails from './RejectionDetails';
import ChargebackActions from './ChargebackActions';
import { getChargebacks } from '../config/api';

const ChargebackList = () => {
  const [chargebacks, setChargebacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchChargebacks();
  }, []);

  const fetchChargebacks = async () => {
    try {
      const data = await getChargebacks();
      if (data.success && data.data) {
        setChargebacks(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching chargebacks:', error);
      setLoading(false);
    }
  };

  const filteredChargebacks = chargebacks.filter(chargeback => {
    if (filter === 'all') return true;
    return chargeback.status === filter;
  });

  const handleStatusChange = (updatedChargeback) => {
    setChargebacks(prev => 
      prev.map(cb => cb.id === updatedChargeback.id ? updatedChargeback : cb)
    );
  };

  if (loading) return <div>Loading chargebacks...</div>;

  return (
    <div className="chargeback-list">
      <div className="list-header">
        <h2>Chargebacks</h2>
        <div className="filters">
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">All</option>
            <option value="VALIDATED">Validated</option>
            <option value="IN_ERROR">Has Errors</option>
            <option value="REJECTED">Rejected</option>
            <option value="PENDING">Pending</option>
          </select>
        </div>
      </div>

      <div className="chargeback-grid">
        {filteredChargebacks.map(chargeback => (
          <div key={chargeback.id} className="chargeback-card">
            <div className="card-header">
              <h3>{chargeback.claimNumber}</h3>
              <StatusBadge 
                status={chargeback.status} 
                validationStatus={chargeback.validationStatus}
                subcategory={chargeback.subcategory}
              />
            </div>
            
            <div className="card-content">
              <ValidationErrors 
                validationErrors={chargeback.validationErrors}
                validationStatus={chargeback.validationStatus}
              />
              
              <RejectionDetails 
                rejectionReasonDetail={chargeback.rejectionReasonDetail}
                rejectionDetails={chargeback.rejectionDetails}
              />
            </div>
            
            <div className="card-actions">
              <ChargebackActions 
                chargeback={chargeback}
                onStatusChange={handleStatusChange}
                currentUser={{ id: 'current-user-id' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChargebackList;
